import { BorrowerOnboardingDetails } from '@nemuru-eng/js-api-client';

import { FamiliarSituationEditDialog } from '@/components/modules/KYC/KYCLoan/BorrowerKYC/components/FamiliarSituation/components/FamiliarSituationEditDialog';
import { FamiliarSituationForm } from '@/components/modules/KYC/KYCLoan/BorrowerKYC/components/FamiliarSituation/components/FamiliarSituationForm';
import { useUpdateBorrowerData } from '@/components/modules/KYC/KYCLoan/BorrowerKYC/hooks/useUpdateBorrowerContract';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { SubSectionWrapper } from '@/components/shared/components/SubSectionWrapper';
import { useDialog } from '@/components/shared/hooks/useDialog';
import { PendingDataType } from '@/config/types';

interface FamiliarSituationProps {
  loanId: string;
  onboardingDetails: BorrowerOnboardingDetails;
  editModeAllowed?: boolean;
}

export const FamiliarSituation = ({ loanId, onboardingDetails, editModeAllowed = false }: FamiliarSituationProps) => {
  const { opened, toggleDialog, setOpened } = useDialog();
  const { updateBorrowerContract, requestLoading } = useUpdateBorrowerData({
    loanId,
    onboardingDetails,
  });
  
  const familiarSituationDetails =
    'userDetails' in onboardingDetails && onboardingDetails?.userDetails?.familiarSituationDetails;

  const toggleEditModeDialog = editModeAllowed && familiarSituationDetails ? toggleDialog : undefined;

  return (
    <SubSectionWrapper title={'FAMILIAR_SITUATION'} toggleEditModeDialog={toggleEditModeDialog}>
      {familiarSituationDetails ? (
        <>
          <FamiliarSituationForm familiarSituationDetails={familiarSituationDetails} fullWidth={false} />
          {opened && (
            <FamiliarSituationEditDialog
              familiarSituationDetails={familiarSituationDetails}
              opened={opened}
              setOpened={setOpened}
              toggleDialog={toggleDialog}
              updateBorrowerContract={updateBorrowerContract}
              loading={requestLoading}
            />
          )}
        </>
      ) : (
        <PendingDataWarning type={PendingDataType.BORROWER_ONBOARDING} />
      )}
    </SubSectionWrapper>
  );
};
